<script lang="ts">
  import Vue from 'vue';
  export default Vue.extend({
    methods: {
      varIOClass(variable): string {
        if (variable.is_input && variable.is_output) {
          return 'input-output'
        } else if (variable.is_input) {
          return 'input-circle'
        } else if (variable.is_output) {
          return 'output-circle'
        } else {
          return 'input-empty'
        }
      },
    }
  });
</script>